import { render, staticRenderFns } from "./changyongyu.vue?vue&type=template&id=0938099a&scoped=true&"
import script from "./changyongyu.vue?vue&type=script&lang=js&"
export * from "./changyongyu.vue?vue&type=script&lang=js&"
import style0 from "./changyongyu.vue?vue&type=style&index=0&id=0938099a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0938099a",
  null
  
)

export default component.exports